import React, { useEffect, useState } from "react";
import QrScanner from "qr-scanner";

/**
 * QRCodeScannerWidget
 *
 * Renders only when siteId === "tali".
 * Shows a button in the Profile menu; when clicked, calls onOpenQR().
 * The actual modal is managed by the parent (HeaderPrivate / MobileHeaderPrivate).
 */
export default function QRCodeScannerWidget({ siteId, onOpenQR }) {
  const [hasCamera, setHasCamera] = useState(false);

  useEffect(() => {
    QrScanner.hasCamera().then((result) => setHasCamera(result));
  }, []);

  if (siteId !== "tali") return null;

  return (
    <button
      type="button"
      className="flex px-4 w-full text-left cursor-pointer transition-colors duration-150"
      onClick={(e) => {
        e.stopPropagation();
        onOpenQR && onOpenQR();
      }}
      onTouchStart={(e) => {
        e.stopPropagation();
      }}
      onTouchEnd={(e) => {
        e.stopPropagation();
        onOpenQR && onOpenQR();
      }}
      tabIndex={0}
      aria-label={hasCamera ? "QR Kod Tara" : "QR Kod Gir"}
    >
      <div className="flex items-center w-full py-4 border-b border-secondary-lines">
        <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 mr-4 overflow-hidden rounded-full bg-secondary-secondary-bg">
          {hasCamera ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-6 text-primary-black">
              <path
                d="M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <rect x="7" y="7" width="3" height="3" rx="0.5" fill="currentColor" />
              <rect x="14" y="7" width="3" height="3" rx="0.5" fill="currentColor" />
              <rect x="7" y="14" width="3" height="3" rx="0.5" fill="currentColor" />
              <path d="M14 14h1v1M17 14v1h-1M14 17h3v-1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-6 text-primary-black">
              <rect x="2" y="6" width="20" height="12" rx="2" stroke="currentColor" strokeWidth="2" />
              <path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M6 14h.01M18 14h.01M10 14h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          )}
        </div>
        <div>
          <h4 className="uppercase text-body">{hasCamera ? "QR KOD TARA" : "QR KOD GİR"}</h4>
        </div>
      </div>
    </button>
  );
}
